import * as React from "react";
import Component from "../../AbstractComponent";
import { TableComponent } from "../../Partials/Table/TableComponent";
import { ChargeInterface } from "../../../Entity/Entities/Charge/ChargeInterface";
import { DeleteEntityPrompt } from "../../Partials/Dialog/DeleteEntityPrompt";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import Formatter from "../../../Localization/Formatter";
import Constants from "../../../Action/Constants";
import ChargeClassContainer from "../../../Entity/Entities/Charge/ChargeClass/ChargeClassContainer";
import PaymentTypeContainer from "../../../Entity/Entities/Payment/PaymentType/PaymentTypeContainer";
import { BankAccountInterface } from "../../../Entity/Entities/BankAccount/BankAccountInterface";
import { PropertyInterface } from "../../../Entity/Entities/Property/PropertyInterface";
import { UnitInterface } from "../../../Entity/Entities/Unit/UnitInterface";
import { ContractInterface } from "../../../Entity/Entities/Contract/ContractInterface";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";
import { Person } from "../../../Entity/Entities/Person/Person";
import { Company } from "../../../Entity/Entities/Company/Company";
import Time from "../../../Time/Time";
import PreventPageLeave from "../../../Middleware/Middlewares/PreventPageLeave";
import { LeavePromptDialog } from "../../Partials/Dialog/LeavePromptDialog";
import { SnoozeDialog } from "../../Partials/Dialog/SnoozeDialog";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import * as ReactTooltip from "react-tooltip";
import { QuickPaymentDialog } from "../../Partials/Dialog/QuickPaymentDialog";
import CreateTaskDialog from "../../Partials/Dialog/CreateTaskDialog";
import Memo from "../../Partials/Memo/Memo";
import * as uuidV4 from "uuid/v4";
import ReportTypeContainer from "../../../Entity/Entities/Report/ReportType/ReportTypeContainer";
import CasedeskUrl from "../../../Url/Url";

export default class Payables extends Component {
  protected selectedCharge: ChargeInterface;
  protected selectedChargeIndex: number;
  public noteField: null;

  protected paginatorPath: string = `Dashboard_Charges`;

  public state = {
    charges: [],
    unpaidCharges: [],
    filter: "unpaid",
    chargeToDelete: null,
    chargeToUnSettle: null,
    isChargeRemovePopupOpen: false,
    isChargeUnSettlePopupOpen: false,
    isSaving: false,
    anchorEl: null,
    hasModifiedData: false,
    openLeavePrompt: false,
    isFetching: true,
    filterValue: "",
    chargesCount: 0,
    unpaidChargesCount: 0,
    chargeToUnlink: null,
    isPaymentUnlinkPopupOpen: false,
    dateFilter: null,
    includePayableFilter: false,
    includeSnoozedFilter: false,
    selectedChargesRows: [],
    selectedCharges: [],
    step: 1,

    paymentChoice: "new",
    amountForPayment: "",
    currencyIdForPayment: null,
    firstDateOfStatementPeriodForPayment: new Date(),
    typeIdForPayment: "",
    typeNameForPayment: "Bank",
    agencyBankAccountIdForPayment: null,
    counterpartyIbanForPayment: "",
    counterpartyIbanForPaymentIsManuallyChanged: false,
    originalCounterpartyIban: "",
    paymentClassId: "",
    payerChoice: "person",
    selectedPersonForPayment: null,
    selectedCompanyForPayment: null,
    descriptionForPayment: "",
    descriptionForPaymentIsManuallyChanged: false,
    isCreateBankAccountPopupOpen: false,
    isChooseExistingChargePopupOpen: false,
    ibanUsedForEntity: null,
    memoPopupOpen: false,
    note: "",
    chargeToAddNote: null,
    isPayChargePopupOpen: null,
    paymentDateQuickOption: new Date(),
    snoozeChargeDialogOpen: false,
    selectedCharge: null,
    isNewTaskPopupOpen: false,
    unpaidSnoozedChargesCount: 0
  };

  protected middlewares: MiddlewareInterface[] = [
    PreventPageLeave
  ];

  constructor(public props) {
    super(props);
  }

  public componentWillMount() {
    this.setState({
      ...this.state,
      ...this.props.app.dashboardPayablesFiltersState
    }, () => {
      this.fetchFirstUnpaidCharges(() => {
        window.scrollTo({
          top: this.props.app?.dashboardChargesListPosition
        });
      });

      const agencyBankAccounts: BankAccountInterface[] = this.props.app.bankAccounts
        .filter((bankAccount: BankAccountInterface) => bankAccount.removed === false)
        .filter((bankAccount: BankAccountInterface) => bankAccount.companyId === this.getAgency()?.id);

      const defaultBankAccount: BankAccountInterface = agencyBankAccounts.find(bankAccount => {
        return bankAccount.isDefault === true;
      });

      let agencyBankAccountId;

      if (!!defaultBankAccount) {
        agencyBankAccountId = !!defaultBankAccount ? defaultBankAccount.id : null;
      } else {
        agencyBankAccountId = !!agencyBankAccounts[0] ? agencyBankAccounts[0].id : null;
      }

      this.setState({
        agencyBankAccountIdForPayment: agencyBankAccountId
      });
    });
  }

  public componentWillReceiveProps(nextProps) {
    if (!this.props?.charges?.requestsOutdated && nextProps?.charges?.requestsOutdated) {
      this.fetchFirstUnpaidCharges();
    }
  }

  public fetchFirstUnpaidCharges = (callback?) => {
    const paginationAmount = !!this.props.app.paginator && !!this.props.app.paginator[this.paginatorPath] ?
      this.props.app.paginator[this.paginatorPath] : this.props.app.defaultPaginationAmount;

    const payload: any = {
      firstItem: 0,
      lastItem: paginationAmount,
      paid: 0, //unpaid charges
      filterValue: this.state.filterValue,
      isAfterStartDate: 1, // do not fetch charges before start date
      hideZeroPayout: 1, // do not fetch payout charges with 0 amount
      isOverdue: 1, // charges not paid in time
      chargeClassId: 2
    };

    if (!!this.state.dateFilter) {
      payload.invoiceDate = this.state.dateFilter;
    }

    if (!this.state.includeSnoozedFilter) {
      payload.isSnoozed = 0;
    } else {
      payload.isSnoozed = 1;
    }

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGES_SAVE_LIST,
      payload: {
        ...payload
      },
      onSuccess: (data) => {
        this.fetchFirstSnoozedUnpaidChargesCount();

        if (!this.state.includeSnoozedFilter) {
          this.props.dispatch({
            type: Constants.GLOBAL_SAVE_UNPAID_PAYABLE_CHARGES_COUNT,
            payload: {
              dashboardPayableChargesCount: data.count
            }
          })
        } else {
          this.props.dispatch({
            type: Constants.GLOBAL_CHARGES_SAVE_LIST,
            payload: {
              ...payload,
              isSnoozed: 0
            },
            onSuccess: (data) => {
              this.props.dispatch({
                type: Constants.GLOBAL_SAVE_UNPAID_PAYABLE_CHARGES_COUNT,
                payload: {
                  dashboardPayableChargesCount: data.count
                }
              })
            }
          })
        }

        this.setState({
          unpaidCharges: data.charges,
          unpaidChargesCount: data.count,
          isFetching: false
        }, () => {
          if (typeof callback === "function") {
            callback();
          }
        })
      }
    });
  }

  public fetchFirstSnoozedUnpaidChargesCount = () => {
    const payload: any = {
      firstItem: 0,
      lastItem: 0,
      paid: 0, //unpaid charges
      filterValue: this.state.filterValue,
      isAfterStartDate: 1, // do not fetch charges before start date
      hideZeroPayout: 1, // do not fetch payout charges with 0 amount
      isOverdue: 1, // charges not paid in time
      isSnoozed: 1,
      chargeClassId: 2
    };

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGES_NOT_SAVE_LIST,
      payload: {
        ...payload
      },
      onSuccess: (data) => {
        this.setState({
          unpaidSnoozedChargesCount: data.count,
          isFetching: false
        })
      },
      onError: () => {
        this.setState({
          isFetching: false
        })
      }
    });
  }

  public fetchFilterAllCharges = () => {
    const payload: any = {
      filterValue: this.state.filterValue,
      isAfterStartDate: 1, // do not fetch charges before start date
      hideZeroPayout: 1, // do not fetch payout charges with 0 amount
      isOverdue: 1, // charges not paid in time
      chargeClassId: 2
    };

    if (!!this.state.dateFilter) {
      payload.invoiceDate = this.state.dateFilter;
    }

    if (!this.state.includeSnoozedFilter) {
      payload.isSnoozed = 0;
    }

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGES_SAVE_LIST,
      payload: {
        ...payload
      },
      onSuccess: data => {
        this.setState({
          charges: data.charges,
          // chargesCount: data.count
        })
      }
    })
  }

  public fetchFilterUnpaidCharges = () => {
    const payload: any = {
      paid: 0, //unpaid charges
      filterValue: this.state.filterValue,
      isAfterStartDate: 1, // do not fetch charges before start date
      hideZeroPayout: 1, // do not fetch payout charges with 0 amount
      isOverdue: 1, // charges not paid in time
      chargeClassId: 2
    };

    if (!!this.state.dateFilter) {
      payload.invoiceDate = this.state.dateFilter;
    }

    if (!this.state.includeSnoozedFilter) {
      payload.isSnoozed = 0;
    }

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGES_SAVE_LIST,
      payload: {
        ...payload
      },
      onSuccess: data => {
        this.setState({
          unpaidCharges: data.charges,
          unpaidChargesCount: data.count
        })
      }
    })
  }

  public fetchCharges = () => {
    if (this.state.filter === "unpaid") {
      const payload: any = {
        firstItem: !!this.state.unpaidCharges ? this.state.unpaidCharges.length : 0,
        lastItem: !!this.state.unpaidCharges ?
          this.state.unpaidCharges.length + this.props.app.defaultPaginationAmount : 0,
        paid: 0, // unpaid charges
        filterValue: this.state.filterValue,
        isAfterStartDate: 1, // do not fetch charges before start date
        hideZeroPayout: 1, // do not fetch payout charges with 0 amount
        isOverdue: 1, // charges not paid in time
        chargeClassId: 2
      };

      if (!!this.state.dateFilter) {
        payload.invoiceDate = this.state.dateFilter;
      }

      if (!this.state.includeSnoozedFilter) {
        payload.isSnoozed = 0;
      }

      this.props.dispatch({
        type: Constants.GLOBAL_CHARGES_SAVE_LIST,
        payload: {
          ...payload
        },
        onSuccess: (data) => {
          const unpaidChargesArr: ChargeInterface[] = !!this.state.unpaidCharges ?
            [...this.state.unpaidCharges, ...data.charges] : [...data.charges];

          this.setState({
            unpaidCharges: unpaidChargesArr,
            unpaidChargesCount: data.count
          });
        }
      });
    }
  }

  public selectDate = (momentDate: any, identifier: string): any => {
    const date = !!momentDate && typeof momentDate.toDate === "function" ? momentDate.toDate() : momentDate;

    this.setState({
      [identifier]: date,
      hasModifiedData: true
    }, () => {
      this.fetchFirstUnpaidCharges();
    });
  }

  public getAmountsOfFilteredCharges = (filter: string): number => {
    switch (filter) {
      case "unpaid":
        return this.state.unpaidChargesCount;
      default:
        return;
    }
  }

  public getFilteredCharges = (filter: string): ChargeInterface[] => {
    switch (filter) {
      case "unpaid":
        return this.state.unpaidCharges
          .filter((charge: ChargeInterface) => charge.removed === false);
      default:
        return;
    }
  }

  protected openMenu = (event: any, charge: ChargeInterface, index: number): void => {
    this.selectedCharge = charge;
    this.selectedChargeIndex = index;

    this.setState({
      anchorEl: event.currentTarget
    });
  }

  protected closeMenu = (): void => {
    this.setState({
      anchorEl: null
    });
  }

  public unSettle = (): any => {
    const charge: ChargeInterface = this.state.chargeToUnSettle;

    this.setState({
      isSaving: true
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_UNSETTLE_START,
      payload: {
        chargeId: charge?.id
      },
      onSuccess: () => {
        this.fetchFirstUnpaidCharges();

        this.setState({ isChargeUnSettlePopupOpen: false, isSaving: false });
      },
      onError: () => {
        this.setState({
          isSaving: false
        });
      }
    });
  }

  public delete = (): void => {
    this.setState({
      isSaving: true
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_DELETE_START,
      payload: {
        charge: this.state.chargeToDelete
      },
      onSuccess: () => {
        this.fetchFirstUnpaidCharges();

        this.setState({
          isChargeRemovePopupOpen: false,
          chargeToDelete: null,
          isSaving: false
        });
      },
      onError: () => {
        this.setState({
          isChargeRemovePopupOpen: false,
          chargeToDelete: null,
          isSaving: false
        });
      }
    });
  }

  public unlink = (): void => {
    const charge = this.state.chargeToUnlink;

    this.setState({
      isSaving: true
    }, () => {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_UNLINK_START,
        payload: {
          charge: charge
        },
        onSuccess: () => {
          this.fetchFirstUnpaidCharges();
          this.setState({ isPaymentUnlinkPopupOpen: false, isSaving: false });
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }

  public saveScrollPosition = () => {
    var top = window.pageYOffset || document.documentElement.scrollTop;

    this.props.dispatch({
      type: Constants.DASHBOARD_CHARGES_LIST_POSITION_SAVE,
      payload: {
        position: top
      }
    });
  }

  public renderChargeMemoIcon = (charge: ChargeInterface) => {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <span>
          <span data-tip={this.getTipText(charge?.note)}>
            <div className={`icon ${charge?.hasMemos ? "icon-ic-bookmark blue-onhover" : "icon-ic-memo"}`}
              onClick={e => {
                e.stopPropagation();
                this.openMemoPopup(charge);
              }}
            >
            </div>
          </span>
          <ReactTooltip place="bottom" />
        </span>
      </div>
    );
  }

  public renderChargeSnoozeIcon = (charge: ChargeInterface) => {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div className={`icon ${charge?.isSnoozed ? "icon-ic-schedule" : "icon-ic-watch-later"}`}
          onClick={e => {
            e.stopPropagation();

            if (charge?.isSnoozed) {
              this.snoozeCharge(charge);
            } else {
              this.setState({
                selectedCharge: charge,
                snoozeChargeDialogOpen: true
              })
            }
          }}
        >
        </div>
      </div>
    );
  }

  public openMemoPopup = (charge: ChargeInterface) => {
    this.setState({
      chargeToAddNote: charge,
      note: charge?.note,
      memoPopupOpen: true,
      anchorEl: null
    });
  }

  public getTipText = (tip: string) => {
    const tipLength = 30;

    if (tip.length > tipLength) {
      return `${tip.slice(0, tipLength)}...`;
    }

    return tip;
  }

  public snoozeCharge = (selectedCharge: ChargeInterface) => {
    if (!selectedCharge) {
      return;
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_SNOOZE_UPDATE_START,
        payload: {
          snoozeDate: !selectedCharge.isSnoozed ? Time.formatOrNull(Time.nextDayFromDate(new Date())) : null,
          chargeId: selectedCharge?.id
        },
        onSuccess: () => {
          this.setState({
            anchorEl: null,
            isSaving: false,
          }, () => {
            this.fetchFirstUnpaidCharges();
          })
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }

  public renderChargeAmountHint = (charge: ChargeInterface) => {
    let status;

    if (charge?.amount === 0) {
			return
		}

    if ((0 < charge?.amountRemaining && charge?.amountRemaining < charge?.amount) && charge?.isPayable) {
      status = `${this.formatter.formatNumber(charge.amountRemaining, charge.currency)} ${this.trans("status-still-to-pay")}`
    } else if ((0 < charge?.amountRemaining && charge?.amountRemaining < charge?.amount) && charge?.isReceivable) {
      status = `${this.formatter.formatNumber(charge.amountRemaining, charge.currency)} ${this.trans("status-still-to-receive")}`
    } else if (charge?.amountRemaining === charge?.amount && charge?.isPayable && !charge.isFullyPaid()) {
      status = `${this.trans("status-to-pay")}`
    } else if (charge?.amountRemaining === charge?.amount && charge?.isReceivable && !charge.isFullyPaid()) {
      status = `${this.trans("status-to-receive")}`
    } else if (charge.isFullyPaid() && charge?.isReceivable) {
      status = `${this.trans("status-received")}`
    } else if (charge.isFullyPaid() && charge?.isPayable) {
      status = `${this.trans("status-amount/paid")}`
    } else {
      status = ""
    }

    return (
      <span
        style={{
          fontSize: "11px",
          color: "#80808091"
        }}
      >
        {status}
      </span>
    );
  }

  public getCharges = (charges: ChargeInterface[], selectedChargesRows: number[], _callback: any): any => {
    return charges
      .map((charge: ChargeInterface, index: number) => {
        if (!charge) {
          return;
        }

        const shouldShowPaidDate = !!charge.oldestPaymentDate;

        let chargeDetails;

        if (charge && charge.description === "") {
          chargeDetails = `${Formatter.monthYearFormatDate(charge.firstDate) ? `${Formatter.monthYearFormatDate(charge.firstDate)},` : ""} ${Formatter.checkTranslationType(this.trans(charge?.type?.label, {}, "", charge?.type?.system), charge?.type?.label, charge?.type?.system)} ${!!charge.relatedEntity ? " - " + charge.relatedEntity.displayName : ""}`
        } else {
          chargeDetails = `${Formatter.monthYearFormatDate(charge.firstDate) ? `${Formatter.monthYearFormatDate(charge.firstDate)},` : ""} ${charge.description} ${!!charge.relatedEntity ? " - " + charge.relatedEntity.displayName : ""}`
        }

        const isItemSelected = selectedChargesRows.includes(index);

        return (
          <TableRow
            hover
            key={`charge-${charge.id}`}
            className={`clickable-entity`}
            onClick={() => {
              this.saveScrollPosition();

              return this.redirect(`/app/charge/update/${charge.id}`);
            }}
            role="checkbox"
            aria-checked={isItemSelected}
            selected={isItemSelected}
          >
            <TableCell
              style={{
                width: "24px",
                paddingLeft: "10px",
                paddingRight: "5px"
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingTop: "4px"
                }}
              >
                <div
                  style={{ color: charge.getIconColor() }}
                  className="icon icon-ic-charge"
                >
                </div>
              </div>
            </TableCell>
            <TableCell style={{ width: "15%" }}>
              {
                shouldShowPaidDate && (
                  <div style={{ display: "inline-flex", flexDirection: "column" }}>
                    <span>{this.formatter.formatDate(charge?.orderDate)}</span>
                    {/* <span style={{ fontSize: "12px", color: "gray" }}>{`${this.trans("status-paid").toLowerCase()}: ${this.formatter.formatDate(charge.oldestPaymentDate)}`}</span> */}
                  </div>
                )
              }
              {
                !shouldShowPaidDate && (
                  <span>{this.formatter.formatDate(charge?.orderDate)}</span>
                )
              }
            </TableCell>
            <TableCell style={{ width: "44%" }}>
              <div style={{ display: "inline-flex", flexDirection: "column" }}>
                <div style={{ display: "flex", justifyContent: "flex-start" }}>
                  {charge?.name || ""}
                  {charge.creationTypeDisplayName && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "2px 0px 0px 5px"
                      }}
                    >
                      <div className="list-label creation-type-label">
                        {charge.creationTypeDisplayName}
                      </div>
                    </div>
                  )}
                </div>
                <span style={{ fontSize: "12px", color: "gray" }}>
                  {chargeDetails}
                </span>
              </div>
            </TableCell>
            <TableCell style={{ width: "10%" }}>
              {
                charge?.isSnoozed &&
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minWidth: "80px"
                  }}
                >
                  <div className="list-label creation-type-label" >
                    {this.trans("label-snoozed")}
                  </div>
                </div>
              }
            </TableCell>
            <TableCell style={{ width: "5%" }}>
              {this.renderChargeSnoozeIcon(charge)}
            </TableCell>
            <TableCell style={{ width: "5%" }}>
              {this.renderChargeMemoIcon(charge)}
            </TableCell>
            <TableCell style={{ textAlign: "right", width: "26%" }}>
              {
                <div style={{ display: "inline-flex", flexDirection: "column" }}>
                  <span>{charge.chargeClass.id == ChargeClassContainer.pickIdFromLabel("Payable") && charge?.amount > 0 && <span className="minus-style">{'-'}</span>}{this.formatter.formatNumber(charge.amount, charge.currency)}</span>
                  {this.renderChargeAmountHint(charge)}
                </div>
              }
            </TableCell>
            <TableCell
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <div>
                <IconButton
                  onClick={e => this.openMenu(e, charge, index)}
                >
                  <div className="icon icon-ic-more-vert"></div>
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorEl}
                  open={Boolean(this.state.anchorEl) && this.selectedCharge && this.selectedCharge.id === charge.id}
                  onClose={this.closeMenu}
                  disableAutoFocusItem={true}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}
                  getContentAnchorEl={null}
                >
                  <MenuItem
                    onClick={() => {
                      return this.redirect(`/app/charge/update/${this.selectedCharge?.id}`);
                    }}
                  >
                    <ListItemIcon><div className="icon icon-ic-edit icon-color"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                  </MenuItem>

                  <MenuItem
                    onClick={() => {
                      if (charge?.isSnoozed) {
                        this.snoozeCharge(charge);
                      } else {
                        this.setState({
                          anchorEl: null,
                          selectedCharge: charge,
                          snoozeChargeDialogOpen: true
                        })
                      }
                    }}
                  >
                    <ListItemIcon><div className={`icon ${this.selectedCharge?.isSnoozed ? "icon-ic-schedule" : "icon-ic-watch-later"} aligned`}></div></ListItemIcon>
                    <ListItemText>{this.selectedCharge?.isSnoozed ? this.trans("unsnooze") : this.trans("snooze")}</ListItemText>
                  </MenuItem>

                  {/* <MenuItem
                    key={`add-task-btn`}
                    onClick={() => {
                      this.setState({
                        isNewTaskPopupOpen: true,
                        anchorEl: null
                      })
                    }
                    }
                  >
                    <ListItemIcon><div className="icon icon-ic-task icon-style-launch-panel"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-create-task")}</ListItemText>
                  </MenuItem> */}

                  <MenuItem
                    key={`add-memo-btn`}
                    onClick={() => this.openMemoPopup(this.selectedCharge)}
                  >
                    <ListItemIcon><div className="icon icon-ic-memo aligned"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-open-memo")}</ListItemText>
                  </MenuItem>

                  <MenuItem
                    className="delete-action"
                    onClick={() => {
                      if (this.checkProcessIsBusy({
                        action: "remove",
                        entityName: "charge",
                        entity: this.selectedCharge
                      })) {
                        this.openIsBusyPopup();
                        this.setState({ anchorEl: null })
                      } else {
                        this.setState({
                          isChargeRemovePopupOpen: true,
                          chargeToDelete: this.selectedCharge,
                          anchorEl: null
                        })
                      }
                    }}
                  >
                    <ListItemIcon><div className="icon icon-ic-remove icon-color remove-icon"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                  </MenuItem>
                </Menu>
              </div>
            </TableCell>
          </TableRow>
        );
      });
  }

  public selectUnselectCharge = (row: number, selectedCharge: ChargeInterface) => {
    if (selectedCharge.amountRemaining === 0 && selectedCharge.amount !== 0) {
      return;
    }

    if (this.state.selectedChargesRows.includes(row)) {
      const selectedChargesRows = this.state.selectedChargesRows.filter(rowId => rowId !== row);
      const selectedCharges = this.state.selectedCharges.filter(charge => charge.id !== selectedCharge.id);

      this.setState({
        selectedChargesRows: selectedChargesRows,
        selectedCharges: selectedCharges
      });
    } else {
      if (this.state.selectedChargesRows.length === this.props.app?.chargesPaymentsLinkedLimitNumber) {
        return this.props.dispatch({
          type: Constants.SNACKBAR_ADD_MESSAGE,
          payload: {
            message: this.trans("section/charge-info/cannottselectchargemaxchargenumberselected", { amount: this.props.app?.chargesPaymentsLinkedLimitNumber }),
            type: "warning"
          }
        });
      }

      this.setState({
        selectedChargesRows: [...this.state.selectedChargesRows, row],
        selectedCharges: [...this.state.selectedCharges, selectedCharge]
      }, () => {
        if (this.state.selectedCharges.length > 0) {
          this.setState({
            hasModifiedData: true
          });
        }
      });
    }
  }

  public onChargeRowSelection = (_event, rows: number[]): void => {
    const row: number = rows[0];
    const charge: ChargeInterface = this.getFilteredCharges(this.state.filter)[row];

    this.selectUnselectCharge(row, charge);
  }

  public goToNextStep = () => {
    let paymentClassId: number = this.state.selectedCharges[0].chargeClass.id;

    if (this.state.selectedCharges.some((charge: ChargeInterface) => charge.chargeClass.id !== paymentClassId)) {
      return this.props.dispatch({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: this.trans("section/charge-info/cannotpaychargeswithdifferentclasses"),
          type: "warning"
        }
      });
    }

    this.props.dispatch({
      type: Constants.GLOBAL_PAYMENT_CREATE_CLEAR
    });

    const chargesUnpaidAmount: number = this.state.selectedCharges.map((charge: ChargeInterface) => {
      const amountUnpaid = charge.amountRemaining;

      return amountUnpaid;
    }).reduce((a, b) => a + b, 0);

    const chargesDescriptions: string[] = this.state.selectedCharges.map((charge: ChargeInterface) => {
      return charge.description;
    });

    // looking for contact details to autofill them in payment section
    let chargeContact: PersonInterface | CompanyInterface = this.state.selectedCharges[0].contact || this.state.selectedCharges[0].company;
    let chargeObject: PropertyInterface | UnitInterface | ContractInterface | any;

    if (!chargeContact) {
      chargeObject = !!this.state.selectedCharges[0].property;
      chargeContact = !!chargeObject ? chargeObject.contact : null;
    }

    if (!chargeObject && !chargeContact) {
      chargeObject = !!this.state.selectedCharges[0] && !!this.state.selectedCharges[0].unit.property ? this.state.selectedCharges[0].unit.property : null;
      chargeContact = !!chargeObject ? chargeObject.contact : null;
    }

    if (!chargeObject && !chargeContact) {
      chargeObject = this.state.selectedCharges[0].contract;
      chargeContact = !!chargeObject ? chargeObject.occupant : null;
    }

    let selectedPersonForPayment = null;
    let selectedCompanyForPayment = null;

    if (!!chargeContact && chargeContact instanceof Person) {
      selectedPersonForPayment = chargeContact;
    }

    if (!!chargeContact && chargeContact instanceof Company) {
      selectedCompanyForPayment = chargeContact;
    }

    this.setState({
      step: 2,

      amountForPayment: Formatter.simpleFormatNumber(chargesUnpaidAmount),
      currencyIdForPayment: this.state.selectedCharges[0].currency.getCurrencyId(),
      firstDateOfStatementPeriodForPayment: this.state.selectedCharges[0].firstDate,
      typeIdForPayment: String(PaymentTypeContainer.pickIdFromLabel("Other")),
      agencyBankAccountIdForPayment: null,
      counterpartyIbanForPayment: "",
      originalCounterpartyIban: "",
      paymentClassId: String(paymentClassId),
      payerChoice: !!selectedCompanyForPayment ? "company" : "person",
      selectedPersonForPayment: selectedPersonForPayment,
      selectedCompanyForPayment: selectedCompanyForPayment,
      descriptionForPayment: chargesDescriptions.join("; "),
      descriptionForPaymentIsManuallyChanged: false,
      hasModifiedData: true
    })
  }

  public openCreateBankAccountPopup = (): void => {
    this.setState({ isCreateBankAccountPopupOpen: true })
  }

  public renderPaymentSection = () => {
    return (
      <div className="box component-payment-create">
        <div className="component-wrapper">
          <div className="component">
          </div>
        </div>
      </div>
    );
  }

  public save = () => {
    const payment: any = {
      amount: parseFloat(parseFloat(String(Formatter.deleteExtraSpace(this.state.amountForPayment)).replace(",", ".")).toFixed(2)),
      currencyId: this.state.currencyIdForPayment,
      currency: this.state.currencyIdForPayment,
      firstDateOfStatementPeriod: Time.formatOrNull(this.state.firstDateOfStatementPeriodForPayment),
      paymentTypeId: Number(this.state.typeIdForPayment),
      agencyBankAccount: this.state.typeNameForPayment === "Bank" ? this.state.agencyBankAccountIdForPayment : null,
      paymentClassId: Number(this.state.paymentClassId),
      description: this.state.descriptionForPayment
    };

    if (this.state.selectedPersonForPayment?.id) {
      payment.contactId = this.state.selectedPersonForPayment?.id;
    }

    if (this.state.selectedCompanyForPayment?.id) {
      payment.companyId = this.state.selectedCompanyForPayment?.id;
    }

    if (Number(this.state.typeIdForPayment) === PaymentTypeContainer.pickIdFromLabel("Bank")) {
      const iban = this.state.counterpartyIbanForPayment;

      if (iban) {
        const company: CompanyInterface = this.props.app.companies.find((company: CompanyInterface) => company.mainBankAccountId === this.state.counterpartyIbanForPayment);
        const person: PersonInterface = this.props.app.persons.find((person: PersonInterface) => person.mainBankAccountId === this.state.counterpartyIbanForPayment);

        if ((!!person &&
          !!this.state.selectedPersonForPayment &&
          (person.id !== this.state.selectedPersonForPayment.id)) || !this.state.selectedPersonForPayment) {
          this.setState({
            ibanUsedForEntity: person
          });
        }

        if ((!!company &&
          !!this.state.selectedCompanyForPayment &&
          (company.id !== this.state.selectedCompanyForPayment.id)) || !this.state.selectedCompanyForPayment) {
          this.setState({
            ibanUsedForEntity: company
          });
        }
      }

      payment.mainBankAccountId = iban;
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_PAYMENT_CREATE_START,
        payload: {
          payment: payment
        },
        onSuccess: payment => {
          this.props.dispatch({
            type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
          });

          this.saving(() => {
            this.props.dispatch({
              type: Constants.GLOBAL_PAYMENT_LINK_START,
              payload: {
                payment: payment,
                chargeIds: this.state.selectedCharges.map((charge: ChargeInterface) => charge.id)
              },
              onSuccess: () => {
                this.props.dispatch({
                  type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
                });

                this.setState({
                  step: 1,
                  selectedChargesRows: [],
                  selectedCharges: [],
                  hasModifiedData: false,
                  isSaving: false
                }, () => {
                  this.fetchFirstUnpaidCharges();
                });
              },
              onError: () => {
                this.setState({
                  hasModifiedData: true,
                  isSaving: false
                });
              }
            });
          });
        },
        onError: () => {
          this.setState({
            hasModifiedData: true,
            isSaving: false
          });
        }
      });
    });
  }

  public changeAmountForPayment = (event): void => {
    let amount: string = event.target.value;
    amount = this.formatter.formatSigns(amount);

    this.setState({
      amountForPayment: amount,
      hasModifiedData: true,
    });
  }

  public changeCurrencyIdForPayment = (event): void => {
    let currency: number = event.target.value;

    this.setState({
      currencyIdForPayment: currency,
      hasModifiedData: true
    });
  }

  public changeTypeIdForPayment = (event): void => {
    const type = String(event.target.value);

    this.setState({
      typeNameForPayment: type == PaymentTypeContainer.pickIdFromLabel("Bank") ? "Bank" : null,
      typeIdForPayment: type,
      hasModifiedData: true,
    });
  }

  public updateAgencyBankAccountIdForPayment = (event): void => {
    const bankAccountId: number = event.target.value;

    if (bankAccountId) {
      this.setState({
        agencyBankAccountIdForPayment: bankAccountId,
        hasModifiedData: true
      });
    }
  }

  public addBankAccount = (bankAccount: object): void => {
    this.setState({
      isSaving: true,
      hasModifiedData: true
    }, () => {
      this.props.dispatch({
        type: Constants.GLOBAL_BANK_ACCOUNT_CREATE_START,
        payload: {
          bankAccount: bankAccount
        },
        onSuccess: (bankAccount: BankAccountInterface) => {
          this.setState({
            isSaving: false,
            isCreateBankAccountPopupOpen: false,
            agencyBankAccountIdForPayment: bankAccount.id
          });
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    })
  }

  public changeCounterpartyIbanForPayment = (event): void => {
    const counterpartyIbanForPayment: string = event.target.value;

    this.setState({
      counterpartyIbanForPayment: counterpartyIbanForPayment,
      counterpartyIbanForPaymentWasChanged: true,
      hasModifiedData: true
    });
  }

  public changePaymentClassId = (event): void => {
    const paymentClassId = String(event.target.value);

    this.setState({
      paymentClassId: paymentClassId,
      hasModifiedData: true
    });
  }

  public changePayerChoice = (event): void => {
    this.clearPersonForPayment();
    this.clearCompanyForPayment();

    const choice: string = event.target.value;

    this.setState({
      payerChoice: choice,
      selectedPersonForPayment: null,
      selectedCompanyForPayment: null,
      hasModifiedData: true,
    });
  }

  public selectPersonForExistingPayments = (person: PersonInterface): void => {
    return this.setState({
      selectedPersonForExistingPayments: person,
    });
  }

  public clearPersonForExistingPayments = (): void => {
    return this.setState({
      selectedPersonForExistingPayments: null
    });
  }

  public selectCompanyForExistingPayments = (company: CompanyInterface): void => {
    return this.setState({
      selectedCompanyForExistingPayments: company
    });
  }

  public clearCompanyForExistingPayments = (): void => {
    return this.setState({
      selectedCompanyForExistingPayments: null
    });
  }

  public selectPersonForPayment = (person: PersonInterface, isManuallySelected: boolean): void => {
    return this.setState({
      selectedPersonForPayment: person,
      hasModifiedData: isManuallySelected ? isManuallySelected : this.state.hasModifiedData,
    }, () => {
      // need this logic to ask if user wants to update iban for person
      if ((!this.state.counterpartyIbanForPayment ||
        (this.state.counterpartyIbanForPayment && !this.state.counterpartyIbanForPaymentIsManuallyChanged))
        && person?.mainBankAccountId) {
        return this.setState({
          counterpartyIbanForPayment: person?.mainBankAccountId,
          originalCounterpartyIban: person?.mainBankAccountId,
          counterpartyIbanForPaymentWasChanged: false
        });
      }
    });
  }

  public clearPersonForPayment = (): void => {
    const personMainBankAccountId: string = this.state.selectedPersonForPayment?.mainBankAccountId;

    return this.setState({
      selectedPersonForPayment: null,
      selectedPersonForCharge: null,
      directIndirectCharges: [],
      selectedDirectIndirectChargesRows: [],
      hasModifiedData: true
    }, () => {
      if (personMainBankAccountId === this.state.counterpartyIbanForPayment) {
        return this.setState({
          counterpartyIbanForPayment: "",
          originalCounterpartyIban: "",
          counterpartyIbanForPaymentWasChanged: false
        });
      }
    });
  }

  public selectCompanyForPayment = (company: CompanyInterface, isManuallySelected: boolean): void => {
    return this.setState({
      selectedCompanyForPayment: company,
      hasModifiedData: isManuallySelected ? isManuallySelected : this.state.hasModifiedData,
    }, () => {
      // need this logic to ask if user wants to update iban for person
      if ((!this.state.counterpartyIbanForPayment ||
        (this.state.counterpartyIbanForPayment && !this.state.counterpartyIbanForPaymentIsManuallyChanged))
        && company?.mainBankAccountId) {
        return this.setState({
          counterpartyIbanForPayment: company?.mainBankAccountId,
          originalCounterpartyIban: company?.mainBankAccountId,
          counterpartyIbanForPaymentWasChanged: false
        });
      }
    });
  }

  public clearCompanyForPayment = (): void => {
    const companyMainBankAccountId: string = this.state.selectedCompanyForPayment?.mainBankAccountId;

    return this.setState({
      selectedCompanyForPayment: null,
      hasModifiedData: true
    }, () => {
      if (companyMainBankAccountId === this.state.counterpartyIbanForPayment) {
        return this.setState({
          counterpartyIbanForPayment: "",
          originalCounterpartyIban: "",
          counterpartyIbanForPaymentWasChanged: false
        });
      }
    });
  }

  public changeDescriptionForPayment = (event): void => {
    const description: string = event.target.value;
    this.setState({
      descriptionForPayment: description,
      descriptionForPaymentIsManuallyChanged: true,
      hasModifiedData: true
    });
  }

  public changeIncludePayableFilter = () => {
    this.setState({
      includePayableFilter: !this.state.includePayableFilter
    }, () => {
      this.fetchFirstUnpaidCharges();
    });

    this.props.dispatch({
      type: Constants.DASHBOARD_PAYABLES_UPDATE_FILTERS_STATE,
      payload: {
        includePayableFilter: !this.state.includePayableFilter,
      }
    });
  }

  public changeIncludeSnoozedFilter = () => {
    this.setState({
      includeSnoozedFilter: !this.state.includeSnoozedFilter
    }, () => {
      this.fetchFirstUnpaidCharges();
    });

    this.props.dispatch({
      type: Constants.DASHBOARD_PAYABLES_UPDATE_FILTERS_STATE,
      payload: {
        includeSnoozedFilter: !this.state.includeSnoozedFilter,
      }
    });
  }
  public saveDraft = (message) => {
    this.setState({
    note: message,
  })}
  
  public saveReminder = (charge: ChargeInterface) => {
    this.saving(() => {
      return this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_UPDATE_START,
        payload: {
          chargeId: charge?.id,
          charge: { note: this.state.note },
          updateMemo: true
        },
        onSuccess: () => {
          // need this to update charge from the list immediately
          this.fetchFirstUnpaidCharges();

          this.setState({
            isSaving: false,
            memoPopupOpen: false
          })
        },
        onError: () => {
          this.setState({ isSaving: false });

          this.props.dispatch({
            type: Constants.SNACKBAR_ADD_MESSAGE,
            payload: {
              message: this.trans("memo-can-not-be-updated"),
              type: "warning"
            }
          });
        }
      });
    });
  }

  public removeReminder = (charge: ChargeInterface) => {
    this.saving(() => {
      return this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_UPDATE_START,
        payload: {
          chargeId: charge?.id,
          charge: { note: "" },
          removeMemo: true
        },
        onSuccess: () => {
          // need this to update charge from the list immediately
          this.fetchFirstUnpaidCharges();
          this.setState({ isSaving: false, memoPopupOpen: false })
        },
        onError: () => {
          this.setState({ isSaving: false });
        }
      });
    });
  }

  public downloadPaylist = () => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_REPORT_DOWNLOAD_START,
        payload: {
          amazonFolderName: uuidV4(),
          reportTypeId: ReportTypeContainer.pickIdFromLabel("payables"),
          localTime: this.formatter.formatTime(new Date())
        },
        onSuccess: url => {
          this.setState({
            isSaving: false
          });

          window.open(CasedeskUrl.getAttachment(url), "_blank")
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }

  public render() {
    return (
      <div>
        {
          this.state.step === 1 && (
            <div>
              <div>
                {
                  this.state.selectedChargesRows.length === 0 && (
                    <div
                      className="list-filters-wrapper"
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "center"
                        }}
                      >
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={this.state.includeSnoozedFilter}
                              onChange={this.changeIncludeSnoozedFilter}
                              color="primary"
                            />
                          }
                          label={`${this.trans("label-include-snoozed-charges")} ${this.state.unpaidSnoozedChargesCount > 0 ? `(${this.state.unpaidSnoozedChargesCount})` : ""}`}
                        />
                      </div>
                      <div>
                        {this.props.renderRadioGroup()}
                      </div>
                    </div>
                  )
                }

                {
                  this.state.selectedChargesRows.length > 0 && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        padding: "14px 24px 14px 65px"
                      }}
                    >
                      <Button
                        color="primary"
                        style={{
                          marginRight: "30px"
                        }}
                        onClick={() => {
                          this.setState({
                            selectedChargesRows: [],
                            selectedCharges: [],
                          })
                        }}
                      >
                        {this.trans("button-clear")}
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.goToNextStep}
                      >
                        {this.trans("button-pay")}
                      </Button>
                    </div>
                  )
                }
              </div>
              <TableComponent
                {...this.props}
                paginator={{
                  name: this.paginatorPath,
                  path: this.props.app.paginator
                }}
                className="listing-table dashboard-unpaid-listing-table with-first-border"
                rows={this.getCharges(this.getFilteredCharges(this.state.filter), this.state.selectedChargesRows, this.onChargeRowSelection)}
                rowsLength={this.getAmountsOfFilteredCharges(this.state.filter)}
                subtitle={this.trans("page/dashboard-tab/unpaid-section/charge-info/chargesnotfound")}
                fetch={this.fetchCharges}
                isFetching={this.state.isFetching}
                filtering={this.state.filterValue?.length > 0}
                headers={[
                  "", this.trans("date"), this.trans("description"), "", "", "", this.trans("label-amount"), ""
                ]}
              />
            </div>
          )
        }

        {
          this.state.step === 2 && (
            <div className="box box-full full-width component-finance has-details-page-header">
              <div className="component-header has-back-button">
                <div className="inner-wrapper" style={{ width: "100%" }}>
                  <div
                    className="back-arrow-wrapper"
                    onClick={() => this.setState({ step: 1, hasModifiedData: false })}
                  >
                    <div className="icon icon-ic-arrow-back icon-color"></div>
                  </div>
                  <div className="title-wrapper">
                    <h1>{this.trans("page/paymentcreate-title")}</h1>
                  </div>
                  <div className="button-container">
                    <Button
                      color="primary"
                      onClick={() => this.setState({ step: 1, hasModifiedData: false })}
                    >
                      {this.trans("button-cancel")}
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={this.save}
                    >
                      {this.trans("button-finish")}
                    </Button>
                  </div>
                </div>
              </div>

              {this.renderPaymentSection()}
            </div>
          )
        }

        <PromptDialog
          {...this.props}
          title={this.trans("memo")}
          content={
            <div>
              <Memo
                {...this.props}
                entity={this.state.chargeToAddNote}
                saveDraft={this.saveDraft}
                relations={{ chargeId: this.state.chargeToAddNote?.id }}
                fetchEntities={() => {
                  this.props.dispatch({
                    type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
                  });

                  this.fetchFirstUnpaidCharges();
                }}
              />
            </div>
          }
          prioritizeClosing={true}
          openLeavePrompt={this.state.memoPopupOpen}
          onlyPositiveButton={true}
          positiveButtonLabel={this.trans("button-close")}
          onSave={() => this.saveReminder(this.state.chargeToAddNote)}
          hideCross={true}
          subtitle={this.state.chargeToAddNote && this.state.chargeToAddNote.displayName ?
            this.state.chargeToAddNote.displayName : ""}
        />

        <QuickPaymentDialog
          {...this.props}
          charge={this.selectedCharge}
          isOpen={this.state.isPayChargePopupOpen}

          initializePage={() => {
            this.setState({
              hasModifiedData: false,
              isPayChargePopupOpen: false
            }, () => {
              this.fetchFirstUnpaidCharges();
            })
          }}

          closeDialog={() => {
            this.setState({
              isPayChargePopupOpen: false,
              isSaving: false,
              anchorEl: null,
            })
          }}
        />

        <SnoozeDialog
          {...this.props}
          entity={this.state.selectedCharge}
          isOpen={this.state.snoozeChargeDialogOpen}

          fetchFirstUnpaidCharges={() => this.fetchFirstUnpaidCharges()}
          closeDialog={() => {
            this.setState({
              snoozeChargeDialogOpen: false,
              isSaving: false,
              anchorEl: null
            })
          }}
        />

        <CreateTaskDialog
          {...this.props}
          entity={this.selectedCharge}
          isOpen={this.state.isNewTaskPopupOpen}

          closeDialog={() => {
            this.setState({
              isNewTaskPopupOpen: false,
              isSaving: false,
              anchorEl: null
            })
          }}
        />

        <DeleteEntityPrompt
          {...this.props}
          entityName={'title-charge-delete-from-charge-page-content-dialog'}
          isOpen={this.state.isChargeRemovePopupOpen}
          onCancel={() => {
            this.setState({
              isChargeRemovePopupOpen: false,
            })
          }}
          onDelete={this.delete}
        />

        <DeleteEntityPrompt
          {...this.props}
          entityName={"charge-unsettle-from-charge-page-content-dialog"}
          isOpen={this.state.isChargeUnSettlePopupOpen}
          onCancel={() => {
            this.setState({
              isChargeUnSettlePopupOpen: false,
            })
          }}
          onDelete={this.unSettle}
          type="button-unsettle"
        />

        <PageTransition isSaving={this.state.isSaving} />

        <DeleteEntityPrompt
          {...this.props}
          entityName={'charge-unlink-info'}
          isOpen={this.state.isPaymentUnlinkPopupOpen}
          onCancel={() => {
            this.setState({
              isPaymentUnlinkPopupOpen: false,
            })
          }}
          onDelete={this.unlink}
          type={"button-continue"}
        />

        <LeavePromptDialog
          {...this.props}
          prioritizeClosing={true}
          onClose={() => this.setState({ openLeavePrompt: false, nextPath: "" })}
          openLeavePrompt={this.state.openLeavePrompt}
          onDiscard={this.leave.bind(this)}
          onSave={() => { this.setState({ openLeavePrompt: false }); this.save(); }}
          hideCross={true}
          leavePrompt={true}
        />
      </div>
    );
  }
}

